<template>
  <v-app class="background">
    <header-component></header-component>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>

</template>


<script>
import HeaderComponent from './modules/header/components/HeaderComponent';

export default {
  name: 'App',
  components: {
    HeaderComponent
  },
  metaInfo: {
    title: 'ChatFight!'
  },
  async created() {
    // 2.7: hydrate the Vuex `user.me` state from GET /users/me. The fetch
    // logic, localStorage mirroring, and post-OAuth session pickup all live
    // inside the Vuex action now (see UserModule.fetchMe) — App.vue is just
    // the trigger. We fetch unconditionally on mount: on a logged-in session
    // (either an HttpOnly post-OAuth cookie or a previously-set
    // localStorage.token mirror) the server returns the v2 UserMeResponse;
    // on no session it 401s and the action no-ops, leaving `state.me = null`.
    //
    // This is a behavior change from v1 — v1 skipped the fetch when
    // `localStorage.token` was already set, saving one API call per page
    // load for already-logged-in users. v2 (2.7) must fetch on every load
    // because the navbar's display derivation requires structured
    // `providers.*` data that localStorage doesn't carry. The one extra
    // request per load is the cost of moving the source of truth onto
    // the server. (It also serves as a session-validity check —
    // a stale localStorage.token without a matching cookie now triggers
    // a logout-on-next-load rather than silently lingering.)
    await this.$store.dispatch('fetchMe');
  },
}
</script>


<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.background {
    width: 100vw;
    height: 100% !important;
    min-height: 100vh !important;
    background-size: cover;
    background-attachment: fixed;
    background: linear-gradient(180deg, rgba(26,88,30,1) 0%, rgba(66,24,105,1) 100%);
}
.v-btn--size-default {
  font-size: 16px;
}
.app-title {
  font-size: 28px;
}
html {
  overflow-y: auto !important;
}
</style>
